import React from "react";

export default function Footer(props) {
    return (
        <footer className="footer">
            <div className="redes">
                <a href="https://www.linkedin.com/in/matias-chanquia/" target="_blank" rel="noreferrer"><img src="https://cdn-icons-png.flaticon.com/512/174/174857.png" alt="logo linkedin"/></a>
                <a href="https://github.com/matiaschanquia" target="_blank" rel="noreferrer"><img src="https://cdn-icons-png.flaticon.com/512/25/25231.png" alt="logo github"/></a>
            </div>
            <p>&copy; Copyright ToDo App - Matias Chanquia Dev</p>
        </footer>
    )
}